function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFestival(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 6,
    fill: "#CA0C64",
    fillOpacity: 0.08,
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5008 22.8388C30.8601 22.8388 31.2047 22.6961 31.4589 22.4421C31.7129 22.1879 31.8557 21.8433 31.8557 21.484V20.7299C31.8568 20.3313 32.0156 19.9495 32.2974 19.6677C32.5792 19.3859 32.961 19.2271 33.3596 19.2259H33.9603C35.0781 19.2259 36.1502 18.7821 36.9412 17.9921C37.7321 17.2021 38.1771 16.1304 38.1783 15.0124V14.2582C38.1783 13.7741 37.92 13.3269 37.5008 13.0849C37.0817 12.8428 36.5651 12.8428 36.146 13.0849C35.7269 13.3269 35.4686 13.7741 35.4686 14.2582V15.0124C35.4674 15.4109 35.3086 15.7927 35.0268 16.0745C34.745 16.3564 34.3632 16.5151 33.9647 16.5163H33.3596C32.2424 16.5174 31.1713 16.9617 30.3815 17.7517C29.5914 18.5416 29.1472 19.6127 29.146 20.7299V21.484C29.146 21.8433 29.2887 22.1879 29.5428 22.4421C29.797 22.6961 30.1415 22.8388 30.5008 22.8388Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2171 39.9999C18.9441 40.0006 19.6656 39.8738 20.3486 39.625L29.7783 36.1974H29.7785C30.8062 35.8359 31.5754 34.9707 31.814 33.9077C32.0526 32.8447 31.7271 31.7337 30.9526 30.9677L21.0171 21.0322C20.253 20.2679 19.1515 19.9469 18.0964 20.1811C17.0413 20.4155 16.1789 21.1724 15.8101 22.1883L12.3598 31.636C11.9011 32.8962 11.8611 34.2706 12.2458 35.5553C12.6304 36.84 13.4193 37.9662 14.4951 38.767C15.5708 39.5677 16.8761 40.0001 18.2172 39.9998L18.2171 39.9999ZM14.9068 32.5618L18.3345 23.1367V23.1368C18.3866 22.9909 18.5098 22.8818 18.661 22.8478C18.8122 22.814 18.9703 22.8599 19.0796 22.9697L29.0151 32.9052C29.1249 33.0145 29.1708 33.1726 29.137 33.3238C29.103 33.475 28.994 33.5982 28.848 33.6504L19.4228 37.078C18.578 37.3862 17.6472 37.3594 16.8215 37.0033C15.9958 36.6473 15.3374 35.989 14.9814 35.1632C14.6253 34.3375 14.5985 33.4067 14.9067 32.5619L14.9068 32.5618Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0769 32.3226C39.0769 33.0709 38.4703 33.6775 37.722 33.6775C36.9737 33.6775 36.3672 33.0709 36.3672 32.3226C36.3672 31.5743 36.9737 30.9678 37.722 30.9678C38.4703 30.9678 39.0769 31.5743 39.0769 32.3226Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6302 24.1934C36.6448 24.2429 34.7011 24.7745 32.9669 25.7424C32.5515 25.9917 32.3005 26.4437 32.3088 26.9282C32.3169 27.4126 32.5828 27.8558 33.0065 28.091C33.43 28.3262 33.9469 28.3174 34.3625 28.0682C35.6732 27.3488 37.1357 26.9495 38.6302 26.903C39.1143 26.903 39.5615 26.6447 39.8035 26.2256C40.0457 25.8065 40.0457 25.2899 39.8035 24.8708C39.5616 24.4516 39.1144 24.1934 38.6302 24.1934L38.6302 24.1934Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1091 14.2626C20.1091 15.0108 19.5025 15.6174 18.7543 15.6174C18.006 15.6174 17.3994 15.0108 17.3994 14.2626C17.3994 13.5143 18.006 12.9077 18.7543 12.9077C19.5025 12.9077 20.1091 13.5143 20.1091 14.2626Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5333 12C25.174 12 24.8294 12.1427 24.5752 12.3968C24.3212 12.651 24.1784 12.9955 24.1784 13.3548C24.128 14.8496 23.7307 16.3122 23.0178 17.6271C22.8198 17.9354 22.7549 18.3105 22.8381 18.6673C22.9214 19.0241 23.1455 19.3321 23.4594 19.5209C23.7734 19.7097 24.1505 19.7632 24.5046 19.6692C24.8588 19.5754 25.1599 19.3421 25.3391 19.0227C26.3077 17.2871 26.8393 15.3418 26.8881 13.3549C26.8881 12.9956 26.7454 12.6511 26.4913 12.3969C26.2371 12.1428 25.8926 12.0001 25.5333 12.0001L25.5333 12Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFestival);
export default __webpack_public_path__ + "static/media/festival.ab79a66ca9f32c1c2caa6abe4602abc7.svg";
export { ForwardRef as ReactComponent };